import { RootState } from "@/data/store";

import { QuestionFormError } from "./types";

export const selectQuestionFormValidation = (state: RootState) =>
  state.questionFormValidation;

export const selectQuestionFormErrors = (state: RootState) =>
  state.questionFormValidation.questionFormErrors;

export const selectQuestionFormErrorsById = (
  state: RootState,
  blockId: string
): QuestionFormError | undefined =>
  state.questionFormValidation.questionFormErrors[blockId];
